//#region imports 
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { Globals } from './globals';
import { SectionObject } from './../shared/model/section.model';
import { environment } from './../../environments/environment';
import { HttpClient } from '@angular/common/http';
import {
  SaveRequestModel, Simulation, SimulationInput, Section, QuestionGroup, Question, Answer,
  ContactDetails, Account
} from './../shared/model/save.model';
import { Injectable } from '@angular/core';
import { formatDate } from '@angular/common';
import { GuaranteeService } from './guarantee.service';
import { AppConstants } from '../app.constants';
import { CharacteristicService } from './characteristic.service';
import { P5xService } from './p5x.service';
import { SignatureService } from './signature.service';
import { DetailsService } from './details.service';
import { SectionService } from './section.service';
//#endregion

@Injectable({
  providedIn: 'root'
})
export class SaveService {
  //#region variables
  private contactDetails: ContactDetails;
  public save = new SaveRequestModel();
  public account = new Account();
  public simulation = new Simulation();
  public simulationInput = new SimulationInput();
  public section = new Section();
  public questionGroup = new QuestionGroup();
  public question = new Question();
  public answer = new Answer();
  public sectionObject: SectionObject;
  simulationToken: string;
  shortToken: string;
  prospectNumber: string;
  projectStatus: string;
  isProjectCompleted = false;
  isProjectInprogress = false;
  AccountChanged: boolean = false;
  simulationStatus: string;
  //#endregion

  //#region methods
  constructor(
    private httpClient: HttpClient, private globals: Globals, private router: Router,
    private translate: TranslateService, private guaranteeService: GuaranteeService,
    private charService: CharacteristicService, private signatureService: SignatureService,
    private detailsService: DetailsService, private p5xService: P5xService,
    private sectionService: SectionService) {
    this.simulation = new Simulation();
    this.save = new SaveRequestModel();
    this.simulationInput = new SimulationInput();
    this.account = new Account();
    this.section = new Section();
    this.question = new Question();
    this.questionGroup = new QuestionGroup();
    this.answer = new Answer();
    this.sectionObject = new SectionObject();
  }

  setContactDetails(value: ContactDetails) {
    const abc = this.contactDetails;
    if (this.charService.getClientIdOrSimulationTokenPresent() && !this.AccountChanged
      && this.contactDetails !== undefined && (this.contactDetails.DateofBirth !== value.DateofBirth
      || this.contactDetails.Name !== value.Name
      || this.contactDetails.FirstName !== value.FirstName
      || this.contactDetails.LastName !== value.LastName
        || this.contactDetails.EmailAddress !== value.EmailAddress
        || this.contactDetails.PostalCode !== value.PostalCode
        || this.contactDetails.Telephone !== value.Telephone)) {

      this.AccountChanged = true;
    }

    this.contactDetails = value;
  }

  getContactDetails(): ContactDetails {
    return this.contactDetails;
  }

  setProspectNumber(value: string) {
    this.prospectNumber = value;
  }

  getProspectNumber() {
    return this.prospectNumber;
  }

  setSimulationToken(value: string) {
    this.simulationToken = value;
  }

  getSimulationToken() {
    return this.simulationToken;
  }

  setShortToken(value: string) {
    this.shortToken = value;
  }

  getShortToken() {
    return this.shortToken;
  }

  setProjectStatus(value: string) {
    this.projectStatus = value;
  }

  getProjectStatus(): string {
    return this.projectStatus;
  }
  setSimulationStatus(value: string) {
    this.simulationStatus = value;
  }

  getSimulationStatus(): string {
    return this.simulationStatus;
  }

  setIsProjectInprogress(value: boolean) {
    this.isProjectInprogress = value;
  }

  getIsProjectInprogress() {
    return this.isProjectInprogress;
  }

  setIsProjectCompleted(value: boolean) {
    this.isProjectCompleted = value;
  }

  getIsProjectCompleted() {
    return this.isProjectCompleted;
  }

  saveSimulation(userDetails, operation) {
    this.save.Tarification = undefined;
    this.save.Evaluation = undefined;
    this.save.Address = undefined;
    this.save.Criteria = undefined;

    this.getSimulationToken();
    const sections = JSON.parse(sessionStorage.getItem('jsonData')).Sections;
    this.simulationInput.Sections = [];
    for (const section in sections) {
      this.section = new Section();
      this.section.SectionId = sections[section].SectionID;
      this.section.SectionKey = sections[section].SectionKey;
      this.section.SectionText = this.translate.instant(sections[section].SectionKey);
      this.section.QuestionGroups = [];

      for (const questionGroup in sections[section].QuestionGroup) {
        this.questionGroup = new QuestionGroup();
        this.questionGroup.QuestionGroupId = sections[section].QuestionGroup[questionGroup].QuestionGroupID;
        this.questionGroup.QuestionGroupKey = sections[section].QuestionGroup[questionGroup].GroupKey;
        this.questionGroup.QuestionGroupText = this.translate.instant(sections[section].QuestionGroup[questionGroup].GroupKey);
        this.questionGroup.Questions = [];
        this.question = new Question();

        for (const question in sections[section].QuestionGroup[questionGroup].Questions) {
          this.question = new Question();
          this.question.QuestionId = sections[section].QuestionGroup[questionGroup].Questions[question].QuestionId;
          this.question.QuestionKey = sections[section].QuestionGroup[questionGroup].Questions[question].QuestionKey;
          this.question.QuestionText = this.translate.instant(sections[section].QuestionGroup[questionGroup].Questions[question].QuestionKey);
          this.question.Answers = [];
          this.answer = new Answer();

          for (const answers in sections[section].QuestionGroup[questionGroup].Questions[question].Answers) {
            this.answer = new Answer();
            this.answer.AnswerKey = sections[section].QuestionGroup[questionGroup].Questions[question].Answers[answers].Answerkey;
            const questionid = sections[section].QuestionGroup[questionGroup].Questions[question].QuestionId;
            if (questionid !== 6 && questionid !== 7 && questionid !== 10 && questionid !== 14 
              && questionid !== 15 && questionid !== 17
              && questionid !== 18 && questionid !== 19 && questionid !== 20 && questionid !== 25 
              && questionid !== 21 && questionid !== 22 && questionid !== 53 && questionid !== 30 
              && questionid !== 31 && questionid !== 33 && questionid !== 34 && questionid !== 35 
              && questionid !== 36 && questionid !== 38)
              {this.answer.AnswerText = this.translate.instant(sections[section].QuestionGroup[questionGroup].Questions[question].Answers[answers].Answerkey); //
              }
              else
              {
                this.answer.AnswerText = sections[section].QuestionGroup[questionGroup].Questions[question].Answers[answers].AnswerText; 
              }
            
            this.answer.ChoiceId = sections[section].QuestionGroup[questionGroup].Questions[question].Answers[answers].ChoiceId;
            this.answer.AnsweredDateTime = sections[section].QuestionGroup[questionGroup].Questions[question].Answers[answers].AnsweredDateTime;

            this.question.Answers.push(this.answer);
          }
          this.questionGroup.Questions.push(this.question);
        }
        this.section.QuestionGroups.push(this.questionGroup);
      }
      this.simulationInput.Sections.push(this.section);
    }
    const today = new Date();
    const isCRMCustomer = this.charService.getClientIdOrSimulationTokenPresent();
    this.simulation.Channel = isCRMCustomer ? 'MYFEDERALE' : 'WEB';
    this.simulation.Version = 1;
    this.simulation.CurrentPage = this.sectionService.getCurrentPage();
    this.simulation.TrackActivity = this.globals.trackPageActivity;
    const arr = this.simulation.CurrentPage.split('-');
    const currentSection = arr[0];
    if (currentSection === 'P1') {
      this.globals.generateSimulation = false;
    } else if (currentSection === 'P2') {
      this.globals.generateSimulation = false;
    } else if (currentSection === 'P3') {
      this.globals.generateSimulation = false;
      const updatedPricingData = this.guaranteeService.getUpdatedPricingData();
      if (updatedPricingData !== undefined && updatedPricingData !== null) {
        this.save.Tarification = this.guaranteeService.getUpdatedPricingData().Tarification;
      } else {
        this.save.Tarification = this.guaranteeService.getInitialPricingData().Tarification;
      }
      this.save.Evaluation = this.guaranteeService.getInitialPricingData().Evaluation;
    } else if (currentSection === 'P4') {
      const isP5X = this.p5xService.getIsP5XPage();
      if (!isP5X) {
        const updatedPricingData = this.guaranteeService.getUpdatedPricingData();
        if (updatedPricingData !== undefined && updatedPricingData !== null) {
          this.save.Tarification = this.guaranteeService.getUpdatedPricingData().Tarification;
        } else {
          this.save.Tarification = this.guaranteeService.getInitialPricingData().Tarification;
        }
        this.save.Evaluation = this.guaranteeService.getInitialPricingData().Evaluation;
        this.globals.generateSimulation = false;
      } else {
        this.simulation.CurrentPage = 'P5X';
        this.globals.generateSimulation = false;
      }
    } else if (currentSection === 'P5') {
      // this.globals.generateSimulation = false; //commented thsi flag should be set to tru for auto simu doc generation
      const updatedPricingData = this.guaranteeService.getUpdatedPricingData();
      if (updatedPricingData !== undefined && updatedPricingData !== null) {
        this.save.Tarification = this.guaranteeService.getUpdatedPricingData().Tarification;
      } else {
        this.save.Tarification = this.guaranteeService.getInitialPricingData().Tarification;
      }
      this.save.Evaluation = this.guaranteeService.getInitialPricingData().Evaluation;
      this.save.Address = this.signatureService.getSaveAddress1();
      if (this.simulation.CurrentPage === 'P5-4' || this.simulation.CurrentPage === 'P5-5') {
        this.save.Criteria = this.signatureService.getSaveCriteria();
      } else if (this.simulation.CurrentPage === 'P5-6') {
        this.save.Criteria = this.signatureService.getSaveCriteria();
      }
    }
    if (operation === 'ReserveRecall') {
      this.simulation.SimulationStage = 'Simulation Reserved';
      const simulationReservationReason = this.p5xService.getSimulationReservationReason();
      if (simulationReservationReason) {
        this.simulation.Simulation_Reservation_Reason = (simulationReservationReason.ID).toString();
      } else {
        this.simulation.Simulation_Reservation_Reason = null;
      }
      this.save.Operation = 'ReserveRecall';
      if (simulationReservationReason.ID === 4 || simulationReservationReason.ID === 3 
        || simulationReservationReason.ID === 10 || simulationReservationReason.ID === 11) 
        {
          this.simulation.SimulationStage = this.getProjectStatus() !== undefined ? this.getProjectStatus() : 'Simulation Reserved';
          const p225AcceptanceCriteriaChecked = this.p5xService.getP225AcceptanceCriteria();
          const p215AcceptanceCriteriaChecked = this.p5xService.getP215AcceptanceCriteria();
          if (!p215AcceptanceCriteriaChecked && !p225AcceptanceCriteriaChecked){
            this.simulation.CurrentPage = 'P4-2';
            this.save.Criteria = this.signatureService.getSaveCriteria();
          }
        }
    } else if (operation === 'Help') {
      this.save.Operation = 'Help';
      const simStage = this.getSimulationStatus();
      if (simStage)
      {
        if (simStage === 'Simulation Reserved')
        {
          this.simulation.SimulationStage = 'Simulation Reserved';
          const simulationReservationReason = this.p5xService.getSimulationReservationReason();
          if (simulationReservationReason) {
            this.simulation.Simulation_Reservation_Reason = (simulationReservationReason.ID).toString();
          } else {
            this.simulation.Simulation_Reservation_Reason = null;
          }
        } else if (simStage === 'Project Reserved')
        {
          this.simulation.SimulationStage = 'Project Reserved';
          const simulationReservationReason = this.p5xService.getSimulationReservationReason();
          if (simulationReservationReason) {
            this.simulation.Simulation_Reservation_Reason = (simulationReservationReason.ID).toString();
          } else {
            this.simulation.Simulation_Reservation_Reason = null;
          }
        } else if (simStage === 'Project Signed')
        {
          this.simulation.SimulationStage = 'Project Signed';
          this.simulation.Simulation_Reservation_Reason = null;
        } else if (simStage === 'Project Completed')
        {
          this.simulation.SimulationStage = 'Project Completed';
          this.simulation.Simulation_Reservation_Reason = null;
        } else {
          this.simulation.SimulationStage = 'Simulation in Progress';
          this.simulation.Simulation_Reservation_Reason = null;
        }
      } else {
        if (this.simulation.CurrentPage === 'P5-7')
        {
          this.simulation.SimulationStage = 'Project Signed';
          this.simulation.Simulation_Reservation_Reason = null;
        }else{
        this.simulation.SimulationStage = 'Simulation in Progress';
        this.simulation.Simulation_Reservation_Reason = null;
        }
      }
    } else if (operation === 'sendSave') {
      this.save.Operation = 'Save';
      this.globals.generateSimulation = true;
      this.simulation.SimulationStage = 'Simulation in Progress';
      this.simulation.Simulation_Reservation_Reason = null;
    } else {
      if(operation === 'ManualSave')
      {
        this.save.Operation = 'ManualSave';
        //to enable simulation document after summary page also.
        if (this.simulation.CurrentPage === 'P5-1' || this.simulation.CurrentPage === 'P5-2' || this.simulation.CurrentPage === 'P5-3' || this.simulation.CurrentPage === 'P5-4')
        {
          this.globals.generateSimulation = true;
          this.globals.sendSimulationMail = true;
        }
      } else {
        this.save.Operation = 'Save';
      }
      // this.save.Operation = 'Save';
      if (this.getProjectStatus() !== undefined) {
        this.simulation.SimulationStage = this.getProjectStatus();
        this.simulation.Simulation_Reservation_Reason = null;
      } else if (this.isProjectCompleted) {
        this.setSimulationStatus('Project Signed');
        this.simulation.SimulationStage = 'Project Signed';
        this.simulation.Simulation_Reservation_Reason = null;
      } else if (this.simulation.CurrentPage === 'P5-5') {
        this.setSimulationStatus('Project Completed');
        this.simulation.SimulationStage = 'Project Completed';
        this.simulation.Simulation_Reservation_Reason = null;
      } else {
        this.setSimulationStatus('Simulation in Progress');
        this.simulation.SimulationStage = 'Simulation in Progress';
        this.simulation.Simulation_Reservation_Reason = null;
      }
    }
    this.simulation.Status = 'In Progress';
    this.simulation.SimulationToken = this.simulationToken;
    this.simulation.StartDate = formatDate(today, 'dd-MM-yyyy hh:mm:ss', 'en-US', '+0530');
    this.simulation.EndDate = formatDate(today, 'dd-MM-yyyy hh:mm:ss', 'en-US', '+0530');
    this.sectionObject = JSON.parse(sessionStorage.getItem('jsonData')).Sections;
    this.account.FirstName = userDetails.firstName;
    this.account.LastName = userDetails.lastName;
    this.account.emailaddress = userDetails.email;
    this.account.telephone = userDetails.phone;
    if (userDetails.code !== null && userDetails.code !== undefined  && userDetails.code !== '') {
      this.account.PostalCode = userDetails.code;
    } else {
      this.account.PostalCode = this.guaranteeService.getPostalCode();
    }
    // this.account.OptionSalesContact = userDetails.simulationOptionChk;
    if (userDetails.simulationOptionChk !== undefined && userDetails.simulationOptionChk !== null && userDetails.simulationOptionChk !== '' ){
      this.account.OptionSalesContact = userDetails.simulationOptionChk;
    } else if (userDetails.optionSalesContact !== undefined && userDetails.optionSalesContact !== null && userDetails.optionSalesContact !== '' ) {
      this.account.OptionSalesContact = userDetails.optionSalesContact;
    } else{
      this.account.OptionSalesContact = false;
    }

    this.account.accountnumber = this.charService.getDecryptedClientId();

    this.account.DateofBirth = userDetails.DateofBirth;

    this.account.Help_Reason = userDetails.reason != null ? userDetails.reason : null;
    this.account.Contact_Preference = userDetails.preference != null ? userDetails.preference : null;
    // this.save.Address=JSON.parse(sessionStorage.getItem('signatureData'));
    this.save.Language = this.guaranteeService.getLanguage();

    this.save.Simulation = this.simulation;
    this.save.SimulationInput = this.simulationInput;
    this.save.Account = this.account;

    if (this.charService.getClientIdOrSimulationTokenPresent() && !this.AccountChanged
      && (this.contactDetails && this.contactDetails.DateofBirth !== this.account.DateofBirth
        || this.contactDetails.FirstName !== this.account.FirstName
        || this.contactDetails.LastName !== this.account.LastName
        || this.contactDetails.EmailAddress !== this.account.emailaddress
        || this.contactDetails.PostalCode !== this.account.PostalCode
        || this.contactDetails.Telephone !== this.account.telephone)) {
      this.AccountChanged = true;
    }

    this.save.Account.ContactChanged = this.AccountChanged;
    this.save.GenerateSimulation = this.globals.generateSimulation;
    this.save.SendSimulationMail = this.globals.sendSimulationMail;
    this.save.SimulationDocumentum = this.globals.SimulationDocumentum;
    // if (this.getIsProjectCompleted()) {
    //   this.simulation.Status = 'PROJECT COMPLETED';
    //   this.simulation.SimulationStage = 'PROJECT COMPLETED';
    // }

    const useMock = AppConstants.UseMock;

    if (useMock) {
      return this.httpClient.get<any>(AppConstants.MockURLS.SaveSimulation);
    } else {
      return this.httpClient.post<any>(environment.apiURL + AppConstants.APIURLS.SaveSimulation, this.save);
    }
  }
  //#endregion
}
